// extracted by mini-css-extract-plugin
export var gap = "layout-module--gap--320b7";
export var navbarHeightTopMargin = "layout-module--navbar-height-top-margin--1ea67";
export var section = "layout-module--section--f40b1";